import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Allocation } from './allocation';
import { Observable } from 'rxjs';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class AllocationService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) { }
  Get(): Observable<Allocation[]> {
    return this.httpClient.get<Allocation[]>(this.baseUrl + 'api/AllocationApi/GetAll')
  }
  Post(allocation: Allocation): Observable<any> {


    return this.httpClient.post(this.baseUrl + 'api/AllocationApi/Add', allocation, { headers: header, observe: 'response' })
  }
  Delete(allocation: Allocation) {

    return this.httpClient.post(this.baseUrl + 'api/AllocationApi/activeordeactive', allocation, { headers: header, observe: 'response' })
  }
  Put(allocation: Allocation): Observable<any> {

    return this.httpClient.put(this.baseUrl + 'api/AllocationApi/Update', allocation, { headers: header, observe: 'response' })
  }
}
